import request from '@/api/request';

const billingRequest = request(process.env.BILLING_API);

export function getDtMapping (params) {
  return billingRequest({
    url: '/dt-mapping-motrak',
    method: 'get',
    params
  });
}


export function createDtMapping (data) {
  return billingRequest({
    url: '/dt-mapping-motrak',
    method: 'post',
    data
  });
}


// WEBPACK FOOTER //
// ./src/api/dtMapping.js